<template>
  <vs-card>
    <div slot="header">
      <h3>
        Relay Control
      </h3>
    </div>
    <vs-row vs-align="center">
      <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
        <span>Relay1 ON/OFF
          <vs-switch v-model="bool1" @click="statechange(true)">
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>
        </span>
      </vs-col>
      <vs-col vs-lg="3" vs-xs="12" vs-sm="6">
        <span>Relay2 ON/OFF
          <vs-switch v-model="bool2" @click="statechange(false)">
            <span slot="on">On</span>
            <span slot="off">Off</span>
          </vs-switch>
        </span>
      </vs-col>
    </vs-row>
  </vs-card>
</template>
<script>

export default {
  name: "Relay",
  props: [
    'type',
  ],
  data: () => ({
    relay1: '',
    relay2: '',
    bool1: false,
    bool2: false
  }),
  methods: {
    statechange(bool) {
      if(bool) {
        this.relay1 = !this.relay1
      }else{
        this.relay2 = !this.relay2
      }
      // console.log(this.relay1,this.relay2)
      this.$vs.loading()
      this.$API.post('updaterelay', {
        relay1: this.relay1,
        relay2: this.relay2
      }).then(() => {
        this.$vs.notify({
          title: "Update Action",
          text: "Complete!",
          color: "success",
          position: "top-center",
          icon: 'check'
        });
        setTimeout(() => {
          this.$vs.loading.close()
        }, 100);
      })
    }
  },
  mounted() {
    this.$API.get('relay').then((result) => {
      // console.log(result.data)
      this.bool1 = result.data[0].relay1
      this.bool2 = result.data[0].relay2
      this.relay1 = result.data[0].relay1
      this.relay2 = result.data[0].relay2
    })
  }
};
</script>

